import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mncvwdzsjkhghgazphdh.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1uY3Z3ZHpzamtoZ2hnYXpwaGRoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE2NTU5NjcsImV4cCI6MjA3NzIzMTk2N30.qDABfgxsAgh82KnWI4bgxnaZvQkNfulnmduaVGtnRYQ'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Squad = 'core' | 'sync' | 'flow'

export interface Vote {
  id?: number
  voter_squad: Squad
  selected_squad: Squad
  question: string
  created_at?: string
}
